'use strict';

// Import Libraries
import React      from 'react';
import classNames from 'classnames';

// Import JS Modules
import { href, link_classes, handleFlyoutMoreClick, handleTopLevelKeyPress, handleFlyoutKeypress } from './utils';

const Dropdown = (props) => {
  const { sublinks } = props.links;

  let $sublinks = (sublinks || []).map((sublink, i) => {
    return (
      <a key={sublink.name + i}
         className={classNames('dropdown-item', link_classes(sublink))}
         href={href(sublink)}>
        { sublink.name }
      </a>
    );
  });

  return (
    <li className={classNames('nav-item dropdown', link_classes(props.links), {show: props.active, 'd-none': props.hidden})}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}>
      <a className="nav-link dropdown-toggle"
         href={href(props.links)}
         onClick={handleClick}>
        { props.links.name }
      </a>
      <button className={classNames('border-0 bg-white nav-item-more px-1', {'show': props.active})}
        onClick={(event) => handleFlyoutMoreClick(event, props)}
        onKeyDown={(event) => handleTopLevelKeyPress(event, props)}
        aria-expanded={props.active ? "true" : "false"}
        aria-label={`Show submenu of ${props.links.name}`}
        aria-haspopup="true">
      </button>
      <div 
        className={classNames('dropdown-menu', {'dropdown-menu-right': props.right, show: props.active, 'd-none': !sublinks.length })}
        onKeyDown={handleFlyoutKeypress(props)}>
        { $sublinks }
      </div>
    </li>
  );

  function handleClick(e) {
    if (href(props.links) == '#') {
      e.preventDefault();
    }
  }
};

export default Dropdown;
